import { jobTitleOptions } from "@helpers/selectHelper";
import { ChangeEvent, useState } from "react";
import { LInputField } from "../../../common/components/LInputField";
import { LSelect, SelectOption } from "../../../common/components/LSelect";

export const TitleSelectOptions = ({ ...props }: TitleSelectProps): JSX.Element => {
    const [showOther, setShowOther] = useState(props.value === "Other");

    const handleSelect = (e: ChangeEvent<HTMLInputElement>): void => {
        setShowOther(e.target.value === "Other");
    };

    return (
        <>
            {!props.hideSelect && (
                <LSelect
                    options={jobTitleOptions}
                    label="Job title"
                    defaultValue={props.value}
                    defaultOption={{ name: "Select job title", value: "" } as SelectOption}
                    onChange={handleSelect}
                    inputName="jobTitle"
                    disabled={props.disabled}
                />
            )}
            {showOther && (
                <LInputField
                    inputName="otherJobTitle"
                    label="Please specify other job title"
                    placeholder="e.g. Clinical Psychologist"
                    defaultValue={props.otherJobTitle}
                    disabled={props.disabled}
                />
            )}
        </>
    );
};

interface TitleSelectProps {
    /** The initial value */
    value?: string;
    /** The other job title field value */
    otherJobTitle?: string;
    disabled?: boolean;
    hideSelect?: boolean;
}
